import { GET_DEV_STAGE, IS_DEV_ENV } from 'common/constants';
import { compose } from 'redux';

const composeEnhancers =
  ((IS_DEV_ENV || GET_DEV_STAGE()) &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;
export default composeEnhancers;
